import { IBasketballPlayoffApi } from '../types';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default (sdk): IBasketballPlayoffApi => {
  const getPlayoff: IBasketballPlayoffApi['getPlayoff'] = (stageId) => {
    if (stageId) {
      const dataForSending = sdk?.config?.dataConfigLang ? { stageId, language: sdk.config.dataConfigLang } : { stageId };
      const playoff = sdk.playoff(dataForSending);

      return playoff.get();
    }

    console.warn('No playoff data is provided');
  };

  return { getPlayoff };
};
